<template>
    <div class="modal fade show modal-style" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                    <h1 class="mb-0"> {{ title }} </h1>
                    <button
                        @click="onClickClose"
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                  </div>
                </div>
              </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="row py-1 mx-auto d-flex align-items-center">
                      <div class="col-12" >
                        <div class="row">
                          <div class="col-12 col-md-6">
                            <label class="form-label">Start Date</label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="date"
                                placeholder=""
                                v-model="formData.start_date"
                            >
                          </div>

                          <div class="col-12 col-md-6">
                            <label class="form-label">End Date </label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="date"
                                placeholder=""
                                v-model="formData.end_date"
                            >
                          </div>

                          <div class="col-12 col-md-6">
                            <label class="form-label">Number Of Days</label>
                            <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="number"
                                placeholder=""
                                readonly
                                v-model="formData.number_of_days"
                            >
                          </div>

                          <div class="col-12 col-md-6">
                            <label class="align-middle">Adjustment Work</label>
                            <v-select
                                placeholder="Select Adjustment Work"
                                v-model="formData.adjustment_type"
                                :options="adjustmentType"
                                :reduce="name => name.value"
                                label="name"
                            />
                          </div>

                          <div class="col-12 col-md-6">
                            <label class="form-label">Emergency Contact</label>
                            <textarea
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="text"
                                placeholder=""
                                v-model="formData.emergency_contact">
                            </textarea>
                          </div>

                          <div class="col-12 col-md-6">
                            <label class="form-label">Purpose</label>
                            <textarea
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="text"
                                placeholder=""
                                v-model="formData.purpose">
                            </textarea>
                          </div>

                          <div class="col-12 col-md-6">
                            <label class="align-middle">Task Assign to (During Leave)</label>
                            <v-select
                                placeholder="Select Employee"
                                v-model="formData.task_assigned_contact_profile_id"
                                :options="contacts"
                                label="name"
                                :reduce="name => name.id"
                            />
                          </div>

                        </div>
                      </div>

                      <div class="col-12 pt-2">
                        <button @click="handleUpdate" class="btn btn-primary btn-block waves-effect waves-float waves-light">
                          Submit
                        </button>
                      </div>

                    </div>
                </div>
            </div>
        </div>
        <Loader v-if="loader"/>
    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleContact from '@/services/modules/contact'

const props = defineProps({
    title: {
        type: String,
        default: 'Update Leave Application'
    },
    type: {
        type: String,
        default: 'all'
    },
    isInTime: {
        type: Boolean,
        default: true
    },
    isEdit:{
      type:Boolean,
      default:false,
    },
    formData: Object,
})

const emit = defineEmits(['getLeaveApplication']);

const {
  updateLeaveApplication,
  fetchTypes,
  getLeaveApplicationNumberOfDays
} = handleHrPayroll()

const { fetchContactProfiles } = handleContact()

const $store = useStore();
const $route = useRoute();
const loading = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const adjustmentType = ref([]);
let contacts = ref([])

let timer = null;
const myLeaveData = {}


const handleUpdate = async () => {
    loading.value = true;
    myLeaveData.id = props.formData.id
    myLeaveData.start_date = props.formData.start_date;
    myLeaveData.end_date = props.formData.end_date;
    myLeaveData.number_of_days = props.formData.number_of_days;
    myLeaveData.adjustment_type = props.formData.adjustment_type;
    myLeaveData.leave_balance_id =  props.formData.leave_balance_id
    myLeaveData.purpose = props.formData.purpose;
    myLeaveData.task_assigned_contact_profile_id = props.formData.task_assigned_contact_profile_id;
    myLeaveData.emergency_contact = props.formData.emergency_contact;
    myLeaveData.status = props.formData.status;
    await updateLA()
}

const updateLA = () => {
  updateLeaveApplication(myLeaveData,myLeaveData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        emit('getLeaveApplication')
        onClickClose()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

const onClickClose = () => {
    $store.state.isModalOpenThree = false;
}

function getQuery() {
    return `?company_id=${$route.params.companyId}`;
}

watch(
    () => [props.formData.start_date, props.formData.end_date],
    ([startDate, endDate]) => {
      if (!startDate || !endDate) return;

      props.formData.number_of_days = 0;

      let query = getQuery();
      query += '&start_date=' + startDate + '&end_date=' + endDate;

      getLeaveApplicationNumberOfDays(query).then(res => {
        if (!res.status) {
          showError(res.message);
          return;
        }
        props.formData.number_of_days = res.data.number_of_days || 0;
      });
    }
);

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      adjustmentType.value = [];
      return
    }

    if (res.data && res.data.leaveAdjustmentType) {
      adjustmentType.value = res.data.leaveAdjustmentType;
    }

  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
  const query = getQuery()
  const contactQuery = query + '&type=employee'
  const contactRes   = fetchContactProfiles(contactQuery)

  Promise.all([
    getTypes(),
    contactRes.then(res => {
      if (res.data) contacts.value = res.data
    }),
  ]).finally(() => {
    loader.value = false
  })
});

</script>

<style scoped>
.modal-style {
    display: block; 
    background: #1c1d1c33
}
.roles-segment {
    margin-top: -13px;
}
.date {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.highlight {
  color: black;
  font-weight: bold;
}
</style>
